module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer162"
    }
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat7#_idTextAnchor063"
    }
  }, [_vm._v("What Exactly Is This Book?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat8#_idTextAnchor064"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat8#_idTextAnchor064"
    }
  }, [_vm._v("How Did I End Up Here?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat8#_idTextAnchor065"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat8#_idTextAnchor065"
    }
  }, [_vm._v("Why Plant-Based Food?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat8#_idTextAnchor066"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat8#_idTextAnchor066"
    }
  }, [_vm._v("How Do I Use This Cookbook?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat9#_idTextAnchor067"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat9#_idTextAnchor067"
    }
  }, [_vm._v("Must-Have Ingredients and Tools")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat9#_idTextAnchor068"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat9#_idTextAnchor068"
    }
  }, [_vm._v("The Pantry: My Favorite Ingredients")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat9#_idTextAnchor069"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat9#_idTextAnchor069"
    }
  }, [_vm._v("Binders, Thickeners, and Fillers")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat9#_idTextAnchor070"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat9#_idTextAnchor070"
    }
  }, [_vm._v("Protein Additives and Texture")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat10#_idTextAnchor071"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat10#_idTextAnchor071"
    }
  }, [_vm._v("Flavor Additives")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat10#_idTextAnchor072"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat10#_idTextAnchor072"
    }
  }, [_vm._v("More Pantry Items to Consider")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat10#_idTextAnchor073"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat10#_idTextAnchor073"
    }
  }, [_vm._v("My Favorite Kitchen Tools and Necessities")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat10#_idTextAnchor074"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat10#_idTextAnchor074"
    }
  }, [_vm._v("Experiment")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat12#_idTextAnchor075"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat12#_idTextAnchor075"
    }
  }, [_vm._v("Making Meat Fat")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat13#_idTextAnchor076"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat13#_idTextAnchor076"
    }
  }, [_vm._v("Making Pure Umami Mushroom Powder")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat14#_idTextAnchor077"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat14#_idTextAnchor077"
    }
  }, [_vm._v("Making Soy Skin")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat14#_idTextAnchor078"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat14#_idTextAnchor078"
    }
  }, [_vm._v("Beef")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat16#_idTextAnchor079"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat16#_idTextAnchor079"
    }
  }, [_vm._v("All-Natural Veggie Burger")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat17#_idTextAnchor080"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat17#_idTextAnchor080"
    }
  }, [_vm._v("Textured Protein Burger")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat20#_idTextAnchor081"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat20#_idTextAnchor081"
    }
  }, [_vm._v("Mushroom Burger")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat21#_idTextAnchor082"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat21#_idTextAnchor082"
    }
  }, [_vm._v("Vegan Wagyu Steak—Marbled Seitan")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat24#_idTextAnchor083"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat24#_idTextAnchor083"
    }
  }, [_vm._v("Textured Mushroom Steak")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat26#_idTextAnchor084"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat26#_idTextAnchor084"
    }
  }, [_vm._v("Watermelon Katsu Steak")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat27#_idTextAnchor085"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat27#_idTextAnchor085"
    }
  }, [_vm._v("Lion’s Mane Mushroom Steak")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat30#_idTextAnchor086"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat30#_idTextAnchor086"
    }
  }, [_vm._v("Washed Flour Meat—Oncle Hu Method")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat32#_idTextAnchor087"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat32#_idTextAnchor087"
    }
  }, [_vm._v("Radish Roast Beef")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat33#_idTextAnchor088"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat33#_idTextAnchor088"
    }
  }, [_vm._v("Impossible Vegan Hot Dog")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat35#_idTextAnchor089"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat35#_idTextAnchor089"
    }
  }, [_vm._v("Hibiscus Meat Tacos")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat38#_idTextAnchor090"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat38#_idTextAnchor090"
    }
  }, [_vm._v("Chicken")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat40#_idTextAnchor091"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat40#_idTextAnchor091"
    }
  }, [_vm._v("Washed Flour Chicken")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat43#_idTextAnchor092"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat43#_idTextAnchor092"
    }
  }, [_vm._v("Pea Protein Chicken")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat43#_idTextAnchor093"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat43#_idTextAnchor093"
    }
  }, [_vm._v("Soy Skin Chicken")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat43#_idTextAnchor094"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat43#_idTextAnchor094"
    }
  }, [_vm._v("Skinned Cauliflower Wings")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat44#_idTextAnchor095"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat44#_idTextAnchor095"
    }
  }, [_vm._v("Grapefruit Meat Chicken")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat45#_idTextAnchor096"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat45#_idTextAnchor096"
    }
  }, [_vm._v("Better Seitan Chicken Nuggets")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat46#_idTextAnchor097"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat46#_idTextAnchor097"
    }
  }, [_vm._v("The Chicken Nugget")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat47#_idTextAnchor098"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat47#_idTextAnchor098"
    }
  }, [_vm._v("Fried Jackfruit Chicken (Nuggets or Patties)")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor035"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat49#_idTextAnchor099"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat49#_idTextAnchor099"
    }
  }, [_vm._v("Twice-Frozen Tofu Chicken Strips")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor036"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat49#_idTextAnchor100"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat49#_idTextAnchor100"
    }
  }, [_vm._v("Eggs (Are Eggs Meat?)")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor037"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat51#_idTextAnchor101"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat51#_idTextAnchor101"
    }
  }, [_vm._v("Better Tofu Scramble")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor038"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat52#_idTextAnchor102"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat52#_idTextAnchor102"
    }
  }, [_vm._v("Pumpkin Seed Egg")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor039"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat53#_idTextAnchor103"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat53#_idTextAnchor103"
    }
  }, [_vm._v("The Secret Tomato “Egg” Yolk Recipe")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor040"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat53#_idTextAnchor104"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat53#_idTextAnchor104"
    }
  }, [_vm._v("Mung Bean Scramble Two Ways")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat57#_idTextAnchor105"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat57#_idTextAnchor105"
    }
  }, [_vm._v("Vegan Cured Egg Yolks")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat58#_idTextAnchor106"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat58#_idTextAnchor106"
    }
  }, [_vm._v("Pork")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat60#_idTextAnchor107"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat60#_idTextAnchor107"
    }
  }, [_vm._v("Daikon Bacon")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor044"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat63#_idTextAnchor108"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat63#_idTextAnchor108"
    }
  }, [_vm._v("Thick-Cut Seitan Bacon")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor045"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat64#_idTextAnchor110"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat64#_idTextAnchor110"
    }
  }, [_vm._v("Bacon from Mochi (Sweet Rice Flour)")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor046"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat65#_idTextAnchor111"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat65#_idTextAnchor111"
    }
  }, [_vm._v("Soy Skin Bacon")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor047"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat66#_idTextAnchor112"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat66#_idTextAnchor112"
    }
  }, [_vm._v("Wheat Starch Bacon and Pepperoni")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor048"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat67#_idTextAnchor113"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat67#_idTextAnchor113"
    }
  }, [_vm._v("Famous Smoked Watermelon Ham")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor049"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat68#_idTextAnchor114"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat68#_idTextAnchor114"
    }
  }, [_vm._v("Beyond Good Sausage")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor050"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat69#_idTextAnchor115"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat69#_idTextAnchor115"
    }
  }, [_vm._v("Mexican Pulled Pork in Birria Tacos")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor051"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat71#_idTextAnchor116"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat71#_idTextAnchor116"
    }
  }, [_vm._v("BBQ Mushroom Ribs")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat73#_idTextAnchor117"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat73#_idTextAnchor117"
    }
  }, [_vm._v("Porkless Pork Rinds")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat73#_idTextAnchor118"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat73#_idTextAnchor118"
    }
  }, [_vm._v("Seafood")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat75#_idTextAnchor119"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat75#_idTextAnchor119"
    }
  }, [_vm._v("Banana Blossom Fried Fish")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat76#_idTextAnchor120"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat76#_idTextAnchor120"
    }
  }, [_vm._v("Celery Root Fried Fish")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat78#_idTextAnchor121"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat78#_idTextAnchor121"
    }
  }, [_vm._v("Carrot Salmon “Lox”")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor057"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat80#_idTextAnchor122"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat80#_idTextAnchor122"
    }
  }, [_vm._v("Vegan Sushi Fish")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor058"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat81#_idTextAnchor123"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat81#_idTextAnchor123"
    }
  }, [_vm._v("Lion’s Mane Crab Cake")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor059"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat83#_idTextAnchor124"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat83#_idTextAnchor124"
    }
  }, [_vm._v("Resources")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor060"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat84#_idTextAnchor125"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat84#_idTextAnchor125"
    }
  }, [_vm._v("Thanks and Acknowledgements")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor061"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/MakingVeganMeat85#_idTextAnchor126"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/MakingVeganMeat85#_idTextAnchor126"
    }
  }, [_vm._v("About the Author")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor062"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b29f59b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MakingVeganMeat-5.vue
// module id = 75
// module chunks = 0